import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import {NilaiEkskulPage } from '../nilai-ekskul/nilai-ekskul.page'
import{ApiService} from '../../../services/api.service';
import { Router} from '@angular/router';

@Component({
  selector: 'app-ekskul-siswa',
  templateUrl: './ekskul-siswa.page.html',
  styleUrls: ['./ekskul-siswa.page.scss'],
})
export class EkskulSiswaPage implements OnInit {

	ekskul: string = 'semester1';

  constructor(
  private modalCtrl:ModalController, 
  private navCtrl:NavController,
  private api:ApiService,
  private router:Router) { }

  ngOnInit() {
    this.getData();
    this.getStudentData();
  }

  dataEkskul:any=[];
  getData()
  {
      var keyApp=localStorage.getItem('keyApp');
      this.api.data('ekskul?key_app='+keyApp,'get','').subscribe(data=>{        
        this.dataEkskul=data;
        console.log(data);
      })
  }

  studentData:any={};
  getStudentData()
  {
    this.api.data('user/me','get','').subscribe(data=>{
        this.studentData=data;
    },error=>{
        this.router.navigate(['/page/tabs/tab2']);
    })
  }

  async modalNilaiEkskul(id) {
   const modal = await this.modalCtrl.create({
      component: NilaiEkskulPage,
      componentProps:{id:id, studentData:this.studentData}
    });
    return await modal.present();
  }

}
